import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../redux/store/Store";
import { getDoctorOnboardingListValue } from "../../redux/effects/ApiCall";
import {
  DataGrid,
  GridCellParams,
  GridColDef,
  GridToolbar,
} from "@mui/x-data-grid";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import {
  AlertColor,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Grid,
  Stack,
} from "@mui/material";
import MWExceptionList from "../../component/MWExceptionList";
import AddDoctorDialog from "./AddDoctorDialog";
import {
  clearDrApproveRejectAPIRes,
  onBoardDoctorIncomplete,
} from "../../redux/doctorsOnboardingImcomplete/API";
import { DocotorOnboardIncompleteBody } from "../../redux/doctorsOnboardingImcomplete/Model";
import { t } from "i18next";
import MWSnackbar from "../../component/MWSnackbar";

export default function DoctorsOnboardingRequest(props: any) {
  const { docOndoardingRequestLoading } = props;
  const [isLoading] = useState(false);
  docOndoardingRequestLoading(isLoading);
  const dispatch = useDispatch();
  const [dataGridArray, setDataGridArray] = useState([] as any[]);
  const [addDrApproveRejectMsgType, setAddDrApproveRejectMsgType] =
    useState<AlertColor>("success");
  const [addDrApproveRejectMsg, setAddDrApproveRejectMsg] = useState("");
  // Call Add chief complaint store
  const AddDrLoadingValue = useSelector(
    (state: AppState) => state.addDoctorvalue.loading
  );
  // Call Dr Approve Reject store
  const drApproveRejectValue = useSelector(
    (state: AppState) => state.doctorOnboardingStatus
  );
  const drApproveRejectLoadingValue = useSelector(
    (state: AppState) => state.addDoctorvalue.loading
  );

  const alertCloseAction = (alertState: boolean) => {
    if (alertState) {
      dispatch(clearDrApproveRejectAPIRes());
    }
  };

  useEffect(() => {
    if (drApproveRejectValue?.successMsg !== undefined) {
      setAddDrApproveRejectMsg(drApproveRejectValue?.successMsg);
      setAddDrApproveRejectMsgType("success");
      dispatch(getDoctorOnboardingListValue());
    }
    if (drApproveRejectValue?.errorMsg !== "") {
      setAddDrApproveRejectMsgType("error");
      setAddDrApproveRejectMsg(drApproveRejectValue?.errorMsg);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drApproveRejectValue]);

  // Get Doctor Onboarding Request List API
  const doctorOnBoardingApproveOrReject = (
    doctorId: any,
    approveOrreject: any
  ) => {
    dispatch(
      onBoardDoctorIncomplete({
        isApproved: approveOrreject,
        onboardReqId: doctorId,
      } as DocotorOnboardIncompleteBody)
    );
  };

  useEffect(() => {
    dispatch(getDoctorOnboardingListValue());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  // call Store
  const AdminDoctorRequestList = useSelector(
    (state: AppState) => state.doctorRequestValue
  );
  const allDoctorRequestValues = AdminDoctorRequestList.doctorRequestValue;
  useEffect(() => {
    if (allDoctorRequestValues !== undefined) {
      let dataPointArr = allDoctorRequestValues.map((element: any) => ({
        id: element.id,
        doctorId: element.id,
        name: element.fullName,
        qualification: element.qualification,
        specialty: element.specialty,
        yearsOfExperience: element.yearsOfExperience,
      }));
      setDataGridArray(dataPointArr);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [AdminDoctorRequestList]);
  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: `${t("docOnboarding.name", { ns: ["home"] })!}`,
      editable: true,
      width: 200,
      align: "left",
      flex: 1,
    },
    {
      field: "qualification",
      headerName: `${t("doctorlistpage.qualification", { ns: ["home"] })!}`,
      editable: true,
      width: 200,
      align: "left",
      flex: 1,
    },
    {
      field: "specialty",
      headerName: `${t("appointmentpage.speciality", { ns: ["home"] })!}`,
      type: "string",
      width: 200,
      align: "left",
      flex: 1,
    },
    {
      field: "yearsOfExperience",
      headerName: `${t("docOnboarding.yearofExp", { ns: ["home"] })!}`,
      sortable: false,
      width: 100,
      align: "left",
      flex: 1,
    },
    {
      field: "doctorId",
      headerName: `${t("docOnboarding.approve", { ns: ["home"] })!}`,
      width: 100,
      align: "left",
      flex: 1,
      renderCell: (params: GridCellParams) => (
        <Button
          startIcon={<CheckIcon />}
          onClick={() => {
            doctorOnBoardingApproveOrReject(params.row.doctorId, "True");
          }}
          variant="outlined"
        >
          {t("docOnboarding.approve", { ns: ["home"] })}
        </Button>
      ),
    },
    {
      field: "id",
      headerName: `${t("appointmentpage.reject", { ns: ["home"] })!}`,
      width: 100,
      align: "left",
      flex: 1,
      renderCell: (params: GridCellParams) => (
        <Button
          startIcon={<CloseIcon />}
          onClick={() => {
            doctorOnBoardingApproveOrReject(params.row.doctorId, "False");
          }}
          variant="outlined"
        >
          {t("appointmentpage.reject", { ns: ["home"] })}
        </Button>
      ),
    },
  ];

  const [showAddDoctorDialog, setShowAddDoctorDialog] = React.useState(false);
  const updateDoctorDialogState = () => {
    setShowAddDoctorDialog(true);
  };
  const updateAddDoctorDialogValFromChild = (passedVal: boolean) => {
    setShowAddDoctorDialog(passedVal);
  };
  // Doctor request Table
  const doctorOnBoardingRequestList = (
    <Card>
      <CardHeader
        title={
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Grid item></Grid>
            <Grid item mt={1}>
              <Button
                variant="contained"
                onClick={updateDoctorDialogState}
                sx={{ textTransform: "none" }}
              >
                {t("docOnboarding.addDoc", { ns: ["home"] })}
              </Button>
            </Grid>
          </Grid>
        }
      />
      <CardContent>
        {allDoctorRequestValues && allDoctorRequestValues.length ? (
          <DataGrid
            rows={dataGridArray}
            columns={columns}
            disableSelectionOnClick
            hideFooter
            hideFooterPagination
            experimentalFeatures={{ newEditingApi: true }}
            autoHeight
            components={{ Toolbar: GridToolbar }}
            componentsProps={{
              toolbar: {
                csvOptions: { disableToolbarButton: true },
                printOptions: { disableToolbarButton: true },
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 250 },
              },
            }}
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
          />
        ) : (
          <MWExceptionList />
        )}
      </CardContent>
    </Card>
  );

  return (
    <Box>
      {AdminDoctorRequestList.loading === true ||
      AddDrLoadingValue === true ||
      drApproveRejectLoadingValue === true
        ? docOndoardingRequestLoading(true)
        : docOndoardingRequestLoading(false)}
      <Container maxWidth="xl">
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="stretch"
          spacing={2}
          pt={2}
        >
          {doctorOnBoardingRequestList}          
          {addDrApproveRejectMsg !== "" ? (
            <Box my={2}>
              <MWSnackbar
                msg={addDrApproveRejectMsg}
                type={addDrApproveRejectMsgType}
                alertClose={alertCloseAction}
              />
            </Box>
          ) : null}
          {showAddDoctorDialog ? (
            <AddDoctorDialog
              addDoctorDialogEnable={showAddDoctorDialog}
              addDoctorDialogUpdateState={updateAddDoctorDialogValFromChild}
            />
          ) : null}
        </Stack>
      </Container>
    </Box>
  );
}
